<!-- =========================================================================================
    File Name: ChangePassword.vue
    Description: Change Password Page
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">{{$t('CHANGE_PASSWORD_TITLE')}}</h4>
                                    <p v-if="isAccountReseted">{{$t('CHANGE_PASSWORD_MESSAGE_RESETED')}}</p>
                                    <p v-if="isNeedPasswordChange">{{$t('CHANGE_PASSWORD_MESSAGE_NEED_CHANGE')}}</p>
                                    <p>{{$t('CHANGE_PASSWORD_MESSAGE')}}</p>
                                </div>

                                <vs-input :label-placeholder="$t('CURRENT_PASSWORD')" type="password" v-model="currentPassword" class="mt-8 w-full" name="currentPassword" ref="currentPassword"
                                 v-validate="{  required: true, min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}" icon-pack="feather" icon="icon-lock" icon-no-border/>
                                <span class="text-danger text-sm" v-show="errors.has('currentPassword')">{{ errors.first('currentPassword') }}</span>

                                <!-- NEW PASSWORD -->
                                <vs-input :label-placeholder="$t('NEW_PASSWORD')" type="password" v-model="newPassword" class="mt-8 w-full" name="newPassword" ref="newPassword"
                                 v-validate="{  required: true, min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}" icon-pack="feather" icon="icon-lock" icon-no-border/>
                                <span class="text-danger text-sm" v-show="errors.has('newPassword')">{{ errors.first('newPassword') }}</span>

                                <!-- CONFIRM NEW PASSWORD -->
                                <vs-input :label-placeholder="$t('CONFIRM_NEW_PASSWORD')"  type="password" v-model="confirmNewPassword" class="mt-8 w-full" name="confirmNewPassword"
                                 v-validate="{  required: true, min:8, max:20, confirmed:'newPassword' }" icon-pack="feather" icon="icon-lock" icon-no-border/>
                                <span class="text-danger text-sm" v-show="errors.has('confirmNewPassword')">{{ errors.first('confirmNewPassword') }}</span>

                                <div class="mt-8">
                                    <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">{{$t('GO_BACK_TO_LOGIN')}}</vs-button>
                                    <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="!validateForm" @click="checkValid" >{{$t('ChangePassword')}}</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleAdmin from "@/store/admin/moduleAdmin.js"

export default {
    data() {
        return {
            value1: '',
            isAccountReseted: false,
            isNeedPasswordChange: false,
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.currentPassword != '' && this.newPassword != '' && this.confirmNewPassword != '';
        },
    },
    created(){
        this.$store.registerModule('dataAdmin', moduleAdmin)
        this.isAccountReseted = this.$route.params.isAccountReseted
        this.isNeedPasswordChange = this.$route.params.isNeedPasswordChange
    },
    methods:{
        checkValid(){
            
            this.$validator.validateAll().then(result => {
                if(result){
                    if(this.currentPassword === this.newPassword){
                        this.errorAlert(this.$t("FAIL"), this.$t("PASSWORD_SAME_MESSAGE"))
                    }else{
                        this.changePassword()
                    }
                }
            })
            .catch((error)=>{
                console.log(error)
                this.errorAlert(this.$t("ERROR"), error.message)
            })
        },
        changePassword(){
            this.$vs.loading()
            let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))

            const obj = {
                adminId : userInfo.userId,
                currentPassword: this.currentPassword,
                newPassword: this.newPassword
            }

            this.$store.dispatch("dataAdmin/changeAdminPassword", obj)
            .then(() => {

                this.$vs.loading.close()
                this.successAlert(this.$t("SUCCESS"),this.$t("CHANGE_PASSWORD_SUCCESS"))
                setTimeout(()=>{
                    window.sessionStorage.clear();
                        this.$router.push('/pages/login')
                },2000)
                
            })
            .catch(error => { 
                 if (error.message === "CURRENT_PASSWORD_IS_NOT_MATCH"){
                    this.errorAlert(this.$t("FAIL"), this.$t("CURRENT_PASSWORD_IS_NOT_MATCH"))
                } else {
                    this.errorAlert(this.$t("ERROR"), error.message)
                }
                this.$vs.loading.close()
            })
            
        }
    },
}
</script>
